export const QUOTE_MEDIA_MM_QUOTE = 'quote-media/mm-quote';
export const QUOTE_MEDIA_PRICE = 'quote-media/price';
export const QUOTE_MEDIA_QUOTE = 'quote-media/quote';
export const QUOTE_MEDIA_SET_AUTH_STATUS = 'quote-media/set-auth-status';
export const QUOTE_MEDIA_SET_CONNECTION_STATUS = 'quote-media/set-connection-status';
export const QUOTE_MEDIA_SET_SID = 'quote-media/set-sid';
export const QUOTE_MEDIA_SET_SYMBOL_LONG_NAME = 'quote-media/set-symbol-long-name';
export const QUOTE_MEDIA_TRADE = 'quote-media/trade';
export const QUOTE_MEDIA_SET_HEADLINES = 'quote-media/set-headlines';
export const QUOTE_MEDIA_COPY_QM_STATE = 'quote-media/copy-qm-state';